import { APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { version } from 'src/app/version';
import { environment } from "src/environments/environment";

const integrations = [

  Sentry.browserTracingIntegration(),

  Sentry.extraErrorDataIntegration({ depth: 3 })
];

export const initSentry = () => {
  if (environment.production) {
    Sentry.init({
      dsn: "https://08011619ef469e279c37540e15d58c1f@sentry.e2innovativ.ch/6",
      release: `apg-components-${environment.name}@${version}`,
      dist: version,
      integrations,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
      tracePropagationTargets: [
        "localhost",
        "qa.assuraprotect.com",
        "www.assuraprotect.com",
        "assuraprotect.com",
        /^https:\/\/assuraprotect\.com/,
        "fe.assuraprotect.com",
        "fe-dev.assuraprotect.com"
      ],
      transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
      transportOptions: {
        bufferSize: 30
      }
    });
  }
};

export function logError(message: string, err: any) {
  console.log(`Error: ${message}: %o`, err);
  Sentry.addBreadcrumb({ message });
  Sentry.captureException(err);
}

export const SentryProviders =
  [
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }), },
    { provide: Sentry.TraceService, deps: [Router], },
    { provide: APP_INITIALIZER, useFactory: () => () => { }, deps: [Sentry.TraceService], multi: true }
  ];
